/* ============================================================
   Empenzo — add-to-cart for the free-shipping booster cards
   ============================================================
   WHY THIS EXISTS INSTEAD OF THE THEME'S <product-form>
     snippets/header-mini-cart.liquid wraps the entire drawer in one
     <form action="/cart">. A nested <form> is invalid HTML — the
     browser drops it — so the drawer could only ever show a link.
     A delegated click handler needs no form at all, so the same
     "Add to cart" button works in the drawer AND on the cart page,
     and it keeps working after Shopify's Section Rendering API
     swaps that HTML out, because the listener lives on document.

   SECTION IDS: READ THEM FROM THE DOM, NEVER HARD-CODE THE FILENAME
     cart.json is a JSON template, so at runtime its sections are
     named template--<n>__main-cart-footer, not main-cart-footer.
     Asking /cart/add.js for the bare filename renders that section
     standalone — with NO blocks — so the response comes back without
     the subtotal or the Check out button. Writing that into the page
     wipes them. Both cart sections print their real id into
     data-id="{{ section.id }}", so that is the only source used
     here. The drawer's two sections are not in a JSON template and
     genuinely are addressed by filename.

   FAIL SAFE
     Every requested section must produce the exact container it is
     supposed to replace. If any one does not, nothing is written and
     the page reloads instead — a reload is always correct, a partial
     write is not.
   ============================================================ */
(function () {
  if (window.__epzFsbReady) return;
  window.__epzFsbReady = true;

  /* node  : the element on the page to update
     id    : section name to fall back to when the node carries no data-id
     inner : the container the theme itself re-renders. When set, it must
             exist on BOTH sides or the swap is refused. */
  var SPECS = [
    { node: '#header-mini-cart-content', id: 'header-mini-cart-content', inner: null },
    { node: '#header-mini-cart-footer', id: 'header-mini-cart-footer', inner: null },
    { node: '#main-cart-items', id: 'main-cart-items', inner: '.js-contents' },
    { node: '#main-cart-footer', id: 'main-cart-footer', inner: '.js-contents' }
  ];

  function plan() {
    var out = [];
    SPECS.forEach(function (s) {
      var el = document.querySelector(s.node);
      if (!el) return;
      out.push({
        node: s.node,
        inner: s.inner,
        section: el.getAttribute('data-id') || s.id
      });
    });
    return out;
  }

  function apply(sections, list) {
    var ok = true;

    list.forEach(function (t) {
      var html = sections[t.section];
      var node = document.querySelector(t.node);
      if (!html || !node) {
        ok = false;
        return;
      }

      var doc = new DOMParser().parseFromString(html, 'text/html');
      /* the response is wrapped in <div id="shopify-section-…">. The cart
         sections print their own id inside it; the drawer sections do not,
         so fall back to the wrapper itself. */
      var fresh = doc.querySelector(t.node) || doc.getElementById('shopify-section-' + t.section);
      if (!fresh) {
        ok = false;
        return;
      }

      if (t.inner) {
        var current = node.querySelector(t.inner);
        var replacement = fresh.querySelector(t.inner);
        if (!current || !replacement) {
          ok = false;
          return;
        }
        current.innerHTML = replacement.innerHTML;
        return;
      }

      node.innerHTML = fresh.innerHTML;
    });

    return ok;
  }

  /* The header sits outside every section swapped above and holds the item
     count. Re-rendering the whole header would destroy the open drawer —
     the drawer is rendered by the header section — so only the count and
     the total label are patched. */
  function refreshHeader() {
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var q = document.querySelector('.head-slot-cart-link-quantity');
        if (q) q.textContent = cart.item_count;

        var label = document.querySelector('.head-slot-nav-link-label');
        if (label && window.Shopify && typeof window.Shopify.formatMoney === 'function') {
          label.textContent = '(' + window.Shopify.formatMoney(cart.total_price) + ')';
        }
      })
      .catch(function () {});
  }

  function root() {
    var r = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
    return r.charAt(r.length - 1) === '/' ? r : r + '/';
  }

  document.addEventListener('click', function (e) {
    var btn = e.target.closest ? e.target.closest('.epz-fsb-add') : null;
    if (!btn) return;

    e.preventDefault();
    if (btn.getAttribute('aria-busy') === 'true') return;

    var variant = btn.getAttribute('data-variant-id');
    if (!variant) return;

    btn.setAttribute('aria-busy', 'true');
    var list = plan();

    fetch(root() + 'cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({
        items: [{ id: Number(variant), quantity: 1 }],
        sections: list
          .map(function (t) {
            return t.section;
          })
          .join(','),
        sections_url: window.location.pathname
      })
    })
      .then(function (r) {
        return r.json().then(function (body) {
          return { ok: r.ok, body: body };
        });
      })
      .then(function (res) {
        if (!res.ok) {
          var box = document.getElementById('mini-cart-error');
          if (box && res.body && res.body.description) box.textContent = res.body.description;
          btn.removeAttribute('aria-busy');
          return;
        }
        if (!res.body.sections || !apply(res.body.sections, list)) {
          window.location.reload();
          return;
        }
        refreshHeader();
        document.dispatchEvent(new CustomEvent('epz:fsb:added', { bubbles: true }));
      })
      .catch(function () {
        window.location.reload();
      });
  });
})();